const _version = "2.7.2"
function version() {
    return _version;
}
export default version
